var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('v-chart',{staticClass:"vchart",style:({height:_vm.vchartHeight,width:_vm.width}),attrs:{"option":_vm.scatterplotOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }